export default "__VITE_ASSET__Cwe8$bLU__"